import React from 'react'
import ConfirmPassword from '../../../Components/Molecules/ForgotPassword/ConfirmPassword'

function ConfirmPasswordTemplate() {
  return (
    <ConfirmPassword />
  )
}

export default ConfirmPasswordTemplate